import { Box, Typography } from '@mui/material';
import { formatTranslation } from 'intl';
import { UserTranslationKeys } from 'intl/keys';
import React from 'react';
import { useIntl } from 'react-intl';
import { AccessErrorInfo, AccessErrorType } from '../types';
import { accessErrorMessageBoxStyle, accessErrorMessageTextStyle } from './styles';

interface AccessErrorMessageProps {
  accessError: AccessErrorInfo;
}

export const AccessErrorMessage = ({
  accessError,
}: AccessErrorMessageProps): React.ReactElement => {
  const intl = useIntl();

  const getMessage = (): string => {
    switch (accessError.type) {
      case AccessErrorType.accountDeleted:
        return formatTranslation(intl, UserTranslationKeys.cardAccountDeleted);
      case AccessErrorType.noSiteAccess:
        return accessError.entityName
          ? formatTranslation(intl, UserTranslationKeys.cardNoSiteAccess, { siteName: accessError.entityName })
          : formatTranslation(intl, UserTranslationKeys.cardNoSiteAccessGeneric);
      case AccessErrorType.noProcessAccess:
        return accessError.entityName
          ? formatTranslation(intl, UserTranslationKeys.cardNoProcessAccess, { processName: accessError.entityName })
          : formatTranslation(intl, UserTranslationKeys.cardNoProcessAccessGeneric);
      case AccessErrorType.noPermissionsRole:
        return formatTranslation(intl, UserTranslationKeys.cardNoPermissionsRole);
      case AccessErrorType.noIssueAccess:
        return formatTranslation(intl, UserTranslationKeys.cardNoIssueAccess);
      default:
        return '';
    }
  };

  return (
    <Box sx={accessErrorMessageBoxStyle}>
      <Typography variant='body2' sx={accessErrorMessageTextStyle}>
        {getMessage()}
      </Typography>
    </Box>
  );
};
